import { Component, OnChanges, Input, Output, EventEmitter, ViewChild, SimpleChanges } from '@angular/core';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';
import { Paginator, PaginatorModule } from 'primeng/paginator';
import { AfTranslateDirective } from '../../modules/translate/directive/af-translate.directive';
import { SharedModule } from 'primeng/api';

@Component({
    selector: 'pagination-control',
    templateUrl: './pagination-control.component.html',
    standalone: true,
    imports: [PaginatorModule, SharedModule, AfTranslateDirective]
})
export class PaginationControlComponent implements OnChanges {
  constructor(private commonUtilsService: CommonUtilsService) { }
  @Input() config:any = {};
  @Input() totalRecords:number = 0;
  @Input() resetPagination: boolean = false;
  @Input() updateCurrentPage: boolean = false;
  @Input() maxPagesIcon: boolean = false;
  @Output() currentPageChange = new EventEmitter();
  @Output() updateCurrentPageChange = new EventEmitter<boolean>();
  @Output() resetPaginationChange = new EventEmitter<boolean>();
  @ViewChild(Paginator) paginator : Paginator;

  paginationControl:any = {
    id: this.commonUtilsService.createId(),
    configuredPagination: false,
    showFirstLastIcon: false,
    showEllipsisPages: false,
    currentPage: 1,
    firstPage: 1,
    pageLinkSize: 5,
    itemsPerPage: 50,
    firstPageText: 0,
    lastPageText: 0,
    pageCount: 0,
    limitNextEllipsis: 0
  };


  ngOnChanges(changes: SimpleChanges): void {
    if(Number.isInteger(this.totalRecords) && ((changes['totalRecords'] && changes['totalRecords'].currentValue !== changes['totalRecords'].previousValue)
        || (changes['resetPagination'] && changes['resetPagination'].currentValue))){
      if(this.resetPagination){
        this.resetPaginationChange.emit(false);
        if(this.paginator){
          this.paginator.changePage(0);
        }

      }
      if (this.updateCurrentPage && this.paginator) {
        setTimeout(() => {
          this.updateCurrentPageChange.emit(false);
          this.paginator.changePage(this.config.currentPage - 1);
        });
      }
      for(let element in this.config){
        if(this.paginationControl[element] !== undefined){
          this.paginationControl[element] = this.config[element];
        }
      }
      this.configurePageText();
      this.paginationControl.pageCount = Math.ceil(this.totalRecords / this.paginationControl.itemsPerPage);
      this.paginationControl.showEllipsisPages = this.paginationControl.pageCount > this.paginationControl.pageLinkSize;
      this.paginationControl.limitNextEllipsis = this.paginationControl.pageCount - this.paginationControl.pageLinkSize + 1;
      if(this.paginator?.paginatorState?.pageCount > this.paginationControl.pageCount){
        setTimeout(() => {
          if(this.paginator){
            this.paginator.changePage(0);
          }
        });
        // this.paginator.changePage(this.paginationControl.pageCount);
      }
    }
  }

  configurePageText(first: number = 1){
    this.paginationControl.firstPageText = first;
    let lastPageText: number = this.paginationControl.firstPageText + this.paginationControl.itemsPerPage - 1;
    this.paginationControl.lastPageText = lastPageText > this.totalRecords?this.totalRecords:lastPageText;
  }

  onPageChange(e:any){
    let firstPageText: number = e.first + 1;
    this.configurePageText(firstPageText);
    this.changeCurrentPage(e.page, e.first);
  }

  changeCurrentPage(page: any, first: any){
    this.paginationControl.currentPage = page + 1;
    this.currentPageChange.emit({currentPage: this.paginationControl.currentPage, firstElement: first});
  }

  onEllipsis(e:any, direction: any){
    e.stopPropagation();
    let newPage : number = 1;
    if (direction === "ascending"){
      newPage = this.paginator.paginatorState.page + 5;
    } else if (direction === "descending"){
      newPage = this.paginator.paginatorState.page - 5;
    }
    this.paginator.changePage(newPage);
    let firstPage: number = newPage * this.paginationControl.itemsPerPage;
    this.changeCurrentPage(newPage, firstPage);
  }
}
